import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { Product } from '../models/product.model';
import { I18nService } from '../services/i18n.service';
import { stripSkuFromDisplayText } from '../utils/storefront-display.util';

@Pipe({
  name: 'productDisplayName',
  standalone: true,
  pure: false,
})
export class ProductDisplayNamePipe implements PipeTransform {
  private sub?: Subscription;

  constructor(private readonly i18n: I18nService, private readonly cdr: ChangeDetectorRef) {
    this.sub = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(value: Product | string | null | undefined): string {
    if (!value) {
      return '';
    }

    if (this.isProduct(value)) {
      const localized = this.i18n.localizeProductName(value.name, value.nameEn, value.nameAr);
      return stripSkuFromDisplayText(localized);
    }

    return stripSkuFromDisplayText(value);
  }

  private isProduct(value: unknown): value is Product {
    return typeof value === 'object' && value !== null && 'id' in value && 'name' in value;
  }
}
